import { inject, Injectable } from '@angular/core';
import { LMIV_ROUTE_PATH } from '@libs/shared/models';
import { CMS_PAGE_ROUTE_CONTEXT, CmsPageRouteContext } from '../cms-page-route-context';

@Injectable({ providedIn: 'root' })
export class LmivNavigationService {
  private readonly routeContext: CmsPageRouteContext | null = inject(CMS_PAGE_ROUTE_CONTEXT, { optional: true });

  public routePath(): string {
    return this.routeContext?.basePath ?? LMIV_ROUTE_PATH;
  }
}
